import { render, staticRenderFns } from "./StatusDropdown.vue?vue&type=template&id=481ed1cd&"
import script from "./StatusDropdown.vue?vue&type=script&lang=js&"
export * from "./StatusDropdown.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('481ed1cd')) {
      api.createRecord('481ed1cd', component.options)
    } else {
      api.reload('481ed1cd', component.options)
    }
    module.hot.accept("./StatusDropdown.vue?vue&type=template&id=481ed1cd&", function () {
      api.rerender('481ed1cd', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/progressbar/Team/components/StatusDropdown.vue"
export default component.exports